var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "119px",
    viewBox: "0 0 86 119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7 Copy 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1157.000000, -391.000000)",
    strokeWidth: 8.52019831
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy-3",
    transform: "translate(1162.000000, 396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-29",
    stroke: "#FFFFFF",
    points: "14.8055823 11.1432585 14.8055823 68.336075 31.7291755 82.3868781 31.7291755 53.5185257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-30",
    stroke: "#FFFFFF",
    points: "76.7269297 0.0523107213 76.7269297 76.0275425 38.3631065 108.129127 4.97379915e-14 76.0275425 4.97379915e-14 -1.42108547e-14"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-31",
    stroke: "#E89F00",
    points: "62.259074 31.733905 62.259074 14.6039352 45.4451183 14.6039352 45.4451183 42.2182634 62.3687115 42.2182634 62.3687115 68.3363616 45.4451183 82.3871647 45.4451183 53.5180958"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.009911c295f48e3b3492c562b0761c7b.svg";
export { ForwardRef as ReactComponent };